module.exports = __webpack_public_path__ + "img/DE03788.d20b5aaf.png";